// eslint-disable-next-line no-unused-vars
var MoveTranslator = {
    "10000000 Volt Thunderbolt": "719",
    "Absorb": "71",
    "Accelerock": "709",
    "Acid": "51",
    "Acid Armor": "151",
    "Acid Downpour": "628",
    "Acid Spray": "491",
    "Acrobatics": "512",
    "Acupressure": "367",
    "Aerial Ace": "332",
    "Aeroblast": "177",
    "After You": "495",
    "Agility": "97",
    "Air Cutter": "314",
    "Air Slash": "403",
    "All-Out Pummeling": "624",
    "Alluring Voice": "914",
    "Ally Switch": "502",
    "Amnesia": "133",
    "Anchor Shot": "677",
    "Ancient Power": "246",
    "Apple Acid": "787",
    "Aqua Cutter": "895",
    "Aqua Jet": "453",
    "Aqua Ring": "392",
    "Aqua Step": "872",
    "Aqua Tail": "401",
    "Armor Cannon": "890",
    "Arm Thrust": "292",
    "Aromatherapy": "312",
    "Aromatic Mist": "597",
    "Assist": "274",
    "Assurance": "372",
    "Astonish": "310",
    "Astral Barrage": "825",
    "Attack Order": "454",
    "Attract": "213",
    "Aura Sphere": "396",
    "Aura Wheel": "783",
    "Aurora Beam": "62",
    "Aurora Veil": "694",
    "Autotomize": "475",
    "Avalanche": "419",
    "Axe Kick": "853",
    "Baby-Doll Eyes": "608",
    "Baddy Bad": "737",
    "Baneful Bunker": "661",
    "Barb Barrage": "839",
    "Barrage": "140",
    "Barrier": "112",
    "Baton Pass": "226",
    "Beak Blast": "690",
    "Beat Up": "251",
    "Behemoth Bash": "782",
    "Behemoth Blade": "781",
    "Belch": "562",
    "Belly Drum": "187",
    "Bestow": "516",
    "Bide": "117",
    "Bind": "20",
    "Bite": "44",
    "Bitter Blade": "891",
    "Bitter Malice": "841",
    "Black Hole Eclipse": "654",
    "Blast Burn": "307",
    "Blaze Kick": "299",
    "Blazing Torque": "896",
    "Bleakwind Storm": "846",
    "Blizzard": "59",
    "Block": "335",
    "Blood Moon": "901",
    "Bloom Doom": "644",
    "Blue Flare": "551",
    "Body Press": "776",
    "Body Slam": "34",
    "Bolt Beak": "754",
    "Bolt Strike": "550",
    "Bone Club": "125",
    "Bonemerang": "155",
    "Bone Rush": "198",
    "Boomburst": "586",
    "Bounce": "340",
    "Bouncy Bubble": "733",
    "Branch Poke": "785",
    "Brave Bird": "413",
    "Breaking Swipe": "784",
    "Breakneck Blitz": "622",
    "Brick Break": "280",
    "Brine": "362",
    "Brutal Swing": "693",
    "Bubble": "145",
    "Bubble Beam": "61",
    "Bug Bite": "450",
    "Bug Buzz": "405",
    "Bulk Up": "339",
    "Bulldoze": "523",
    "Bullet Punch": "418",
    "Bullet Seed": "331",
    "Burning Bulwark": "908",
    "Burning Jealousy": "807",
    "Burn Up": "682",
    "Buzzy Buzz": "734",
    "Calm Mind": "347",
    "Camouflage": "293",
    "Captivate": "445",
    "Catastropika": "658",
    "Ceaseless Edge": "845",
    "Celebrate": "606",
    "Charge": "268",
    "Charge Beam": "451",
    "Charm": "204",
    "Chatter": "448",
    "Chilling Water": "886",
    "Chilly Reception": "881",
    "Chip Away": "498",
    "Chloroblast": "835",
    "Circle Throw": "509",
    "Clamp": "128",
    "Clanging Scales": "691",
    "Clangorous Soul": "775",
    "Clangorous Soulblaze": "728",
    "Clear Smog": "499",
    "Close Combat": "370",
    "Coaching": "811",
    "Coil": "489",
    "Collision Course": "878",
    "Combat Torque": "899",
    "Comet Punch": "4",
    "Comeuppance": "894",
    "Confide": "590",
    "Confuse Ray": "109",
    "Confusion": "93",
    "Constrict": "132",
    "Continental Crush": "632",
    "Conversion": "160",
    "Conversion 2": "176",
    "Copycat": "383",
    "Core Enforcer": "687",
    "Corkscrew Crash": "638",
    "Corrosive Gas": "810",
    "Cosmic Power": "322",
    "Cotton Guard": "538",
    "Cotton Spore": "178",
    "Counter": "68",
    "Court Change": "756",
    "Covet": "343",
    "Crabhammer": "152",
    "Crafty Shield": "578",
    "Cross Chop": "238",
    "Cross Poison": "440",
    "Crunch": "242",
    "Crush Claw": "306",
    "Crush Grip": "462",
    "Curse": "174",
    "Cut": "15",
    "Darkest Lariat": "663",
    "Dark Pulse": "399",
    "Dark Void": "464",
    "Dazzling Gleam": "605",
    "Decorate": "777",
    "Defend Order": "455",
    "Defense Curl": "111",
    "Defog": "432",
    "Destiny Bond": "194",
    "Detect": "197",
    "Devastating Drake": "652",
    "Diamond Storm": "591",
    "Dig": "91",
    "Disable": "50",
    "Disarming Voice": "574",
    "Discharge": "435",
    "Dire Claw": "827",
    "Dive": "291",
    "Dizzy Punch": "146",
    "Doodle": "867",
    "Doom Desire": "353",
    "Double-Edge": "38",
    "Double Hit": "458",
    "Double Iron Bash": "742",
    "Double Kick": "24",
    "Double Shock": "892",
    "Double Slap": "3",
    "Double Team": "104",
    "Draco Meteor": "434",
    "Dragon Ascent": "620",
    "Dragon Breath": "225",
    "Dragon Cheer": "913",
    "Dragon Claw": "337",
    "Dragon Dance": "349",
    "Dragon Darts": "751",
    "Dragon Energy": "820",
    "Dragon Hammer": "692",
    "Dragon Pulse": "406",
    "Dragon Rage": "82",
    "Dragon Rush": "407",
    "Dragon Tail": "525",
    "Draining Kiss": "577",
    "Drain Punch": "409",
    "Dream Eater": "138",
    "Drill Peck": "65",
    "Drill Run": "529",
    "Drum Beating": "778",
    "Dual Chop": "530",
    "Dual Wingbeat": "814",
    "Dynamax Cannon": "744",
    "Dynamic Punch": "223",
    "Earth Power": "414",
    "Earthquake": "89",
    "Echoed Voice": "497",
    "Eerie Impulse": "598",
    "Eerie Spell": "826",
    "Egg Bomb": "121",
    "Electric Terrain": "604",
    "Electrify": "582",
    "Electro Ball": "486",
    "Electro Drift": "879",
    "Electro Shot": "905",
    "Electroweb": "527",
    "Embargo": "373",
    "Ember": "52",
    "Encore": "227",
    "Endeavor": "283",
    "Endure": "203",
    "Energy Ball": "412",
    "Entrainment": "494",
    "Eruption": "284",
    "Esper Wing": "840",
    "Eternabeam": "795",
    "Expanding Force": "797",
    "Explosion": "153",
    "Extrasensory": "326",
    "Extreme Evoboost": "702",
    "Extreme Speed": "245",
    "Facade": "263",
    "Fairy Lock": "587",
    "Fairy Wind": "584",
    "Fake Out": "252",
    "Fake Tears": "313",
    "False Surrender": "793",
    "False Swipe": "206",
    "Feather Dance": "297",
    "Feint": "364",
    "Feint Attack": "185",
    "Fell Stinger": "565",
    "Fickle Beam": "907",
    "Fiery Dance": "552",
    "Fiery Wrath": "822",
    "Fillet Away": "868",
    "Final Gambit": "515",
    "Fire Blast": "126",
    "Fire Fang": "424",
    "Fire Lash": "680",
    "Fire Pledge": "519",
    "Fire Punch": "7",
    "Fire Spin": "83",
    "First Impression": "660",
    "Fishious Rend": "755",
    "Fissure": "90",
    "Flail": "175",
    "Flame Burst": "481",
    "Flame Charge": "488",
    "Flame Wheel": "172",
    "Flamethrower": "53",
    "Flare Blitz": "394",
    "Flash": "148",
    "Flash Cannon": "430",
    "Flatter": "260",
    "Fleur Cannon": "705",
    "Fling": "374",
    "Flip Turn": "812",
    "Floaty Fall": "731",
    "Floral Healing": "666",
    "Flower Shield": "579",
    "Flower Trick": "870",
    "Fly": "19",
    "Flying Press": "560",
    "Focus Blast": "411",
    "Focus Energy": "116",
    "Focus Punch": "264",
    "Follow Me": "266",
    "Force Palm": "395",
    "Foresight": "193",
    "Forest's Curse": "571",
    "Foul Play": "492",
    "Freeze-Dry": "573",
    "Freeze Shock": "553",
    "Freezing Glare": "821",
    "Freezy Frost": "739",
    "Frenzy Plant": "338",
    "Frost Breath": "524",
    "Frustration": "218",
    "Fury Attack": "31",
    "Fury Cutter": "210",
    "Fury Swipes": "154",
    "Fusion Bolt": "559",
    "Fusion Flare": "558",
    "Future Sight": "248",
    "Gastro Acid": "380",
    "Gear Grind": "544",
    "Gear Up": "674",
    "Genesis Supernova": "703",
    "Geomancy": "601",
    "Giga Drain": "202",
    "Giga Impact": "416",
    "Gigaton Hammer": "893",
    "Gigavolt Havoc": "646",
    "Glacial Lance": "824",
    "Glaciate": "549",
    "Glaive Rush": "862",
    "Glare": "137",
    "Glitzy Glow": "736",
    "G-Max Befuddle": "1000",
    "G-Max Cannonade": "1000",
    "G-Max Centiferno": "1000",
    "G-Max Chi Strike": "1000",
    "G-Max Cuddle": "1000",
    "G-Max Depletion": "1000",
    "G-Max Drum Solo": "1000",
    "G-Max Finale": "1000",
    "G-Max Fireball": "1000",
    "G-Max Foam Burst": "1000",
    "G-Max Gold Rush": "1000",
    "G-Max Gravitas": "1000",
    "G-Max Hydrosnipe": "1000",
    "G-Max Malodor": "1000",
    "G-Max Meltdown": "1000",
    "G-Max One Blow": "1000",
    "G-Max Rapid Flow": "1000",
    "G-Max Replenish": "1000",
    "G-Max Resonance": "1000",
    "G-Max Sandblast": "1000",
    "G-Max Smite": "1000",
    "G-Max Snooze": "1000",
    "G-Max Steelsurge": "1000",
    "G-Max Stonesurge": "1000",
    "G-Max Stun Shock": "1000",
    "G-Max Sweetness": "1000",
    "G-Max Tartness": "1000",
    "G-Max Terror": "1000",
    "G-Max Vine Lash": "1000",
    "G-Max Volcalith": "1000",
    "G-Max Volt Crash": "1000",
    "G-Max Wildfire": "1000",
    "G-Max Wind Rage": "1000",
    "Grass Knot": "447",
    "Grass Pledge": "520",
    "Grass Whistle": "320",
    "Grassy Glide": "803",
    "Grassy Terrain": "580",
    "Grav Apple": "788",
    "Gravity": "356",
    "Growl": "45",
    "Growth": "74",
    "Grudge": "288",
    "Guardian of Alola": "698",
    "Guard Split": "470",
    "Guard Swap": "385",
    "Guillotine": "12",
    "Gunk Shot": "441",
    "Gust": "16",
    "Gyro Ball": "360",
    "Hail": "258",
    "Hammer Arm": "359",
    "Happy Hour": "603",
    "Harden": "106",
    "Hard Press": "912",
    "Haze": "114",
    "Headbutt": "29",
    "Head Charge": "543",
    "Headlong Rush": "838",
    "Head Smash": "457",
    "Heal Bell": "215",
    "Heal Block": "377",
    "Healing Wish": "361",
    "Heal Order": "456",
    "Heal Pulse": "505",
    "Heart Stamp": "531",
    "Heart Swap": "391",
    "Heat Crash": "535",
    "Heat Wave": "257",
    "Heavy Slam": "484",
    "Helping Hand": "270",
    "Hex": "506",
    "Hidden Power": "237",
    "Hidden Power Bug": "237",
    "Hidden Power Dark": "237",
    "Hidden Power Dragon": "237",
    "Hidden Power Electric": "237",
    "Hidden Power Fighting": "237",
    "Hidden Power Fire": "237",
    "Hidden Power Flying": "237",
    "Hidden Power Ghost": "237",
    "Hidden Power Grass": "237",
    "Hidden Power Ground": "237",
    "Hidden Power Ice": "237",
    "Hidden Power Poison": "237",
    "Hidden Power Psychic": "237",
    "Hidden Power Rock": "237",
    "Hidden Power Steel": "237",
    "Hidden Power Water": "237",
    "High Horsepower": "667",
    "High Jump Kick": "136",
    "Hold Back": "610",
    "Hold Hands": "607",
    "Hone Claws": "468",
    "Horn Attack": "30",
    "Horn Drill": "32",
    "Horn Leech": "532",
    "Howl": "336",
    "Hurricane": "542",
    "Hydro Cannon": "308",
    "Hydro Pump": "56",
    "Hydro Steam": "876",
    "Hydro Vortex": "642",
    "Hyper Beam": "63",
    "Hyper Drill": "887",
    "Hyper Fang": "158",
    "Hyperspace Fury": "621",
    "Hyperspace Hole": "593",
    "Hyper Voice": "304",
    "Hypnosis": "95",
    "Ice Ball": "301",
    "Ice Beam": "58",
    "Ice Burn": "554",
    "Ice Fang": "423",
    "Ice Hammer": "665",
    "Ice Punch": "8",
    "Ice Shard": "420",
    "Ice Spinner": "861",
    "Icicle Crash": "556",
    "Icicle Spear": "333",
    "Icy Wind": "196",
    "Imprison": "286",
    "Incinerate": "510",
    "Infernal Parade": "844",
    "Inferno": "517",
    "Inferno Overdrive": "640",
    "Infestation": "611",
    "Ingrain": "275",
    "Instruct": "689",
    "Ion Deluge": "569",
    "Iron Defense": "334",
    "Iron Head": "442",
    "Iron Tail": "231",
    "Ivy Cudgel": "904",
    "Jaw Lock": "746",
    "Jet Punch": "857",
    "Judgment": "449",
    "Jump Kick": "26",
    "Jungle Healing": "816",
    "Karate Chop": "2",
    "Kinesis": "134",
    "King's Shield": "588",
    "Knock Off": "282",
    "Kowtow Cleave": "869",
    "Land's Wrath": "616",
    "Laser Focus": "673",
    "Lash Out": "808",
    "Last Resort": "387",
    "Last Respects": "854",
    "Lava Plume": "436",
    "Leafage": "670",
    "Leaf Blade": "348",
    "Leaf Storm": "437",
    "Leaf Tornado": "536",
    "Leech Life": "141",
    "Leech Seed": "73",
    "Leer": "43",
    "Let's Snuggle Forever": "726",
    "Lick": "122",
    "Life Dew": "791",
    "Light of Ruin": "617",
    "Light Screen": "113",
    "Light That Burns the Sky": "723",
    "Liquidation": "710",
    "Lock-On": "199",
    "Lovely Kiss": "142",
    "Low Kick": "67",
    "Low Sweep": "490",
    "Lucky Chant": "381",
    "Lumina Crash": "855",
    "Lunar Blessing": "849",
    "Lunar Dance": "461",
    "Lunge": "679",
    "Luster Purge": "295",
    "Mach Punch": "183",
    "Magical Leaf": "345",
    "Magical Torque": "900",
    "Magic Coat": "277",
    "Magic Powder": "750",
    "Magic Room": "478",
    "Magma Storm": "463",
    "Magnet Bomb": "443",
    "Magnetic Flux": "602",
    "Magnet Rise": "393",
    "Magnitude": "222",
    "Make It Rain": "874",
    "Malicious Moonsault": "696",
    "Malignant Chain": "919",
    "Mat Block": "561",
    "Matcha Gotcha": "902",
    "Max Airstream": "766",
    "Max Darkness": "772",
    "Max Flare": "757",
    "Max Flutterby": "758",
    "Max Geyser": "765",
    "Max Guard": "743",
    "Max Hailstorm": "763",
    "Max Knuckle": "761",
    "Max Lightning": "759",
    "Max Mindstorm": "769",
    "Max Ooze": "764",
    "Max Overgrowth": "773",
    "Max Phantasm": "762",
    "Max Quake": "771",
    "Max Rockfall": "770",
    "Max Starfall": "767",
    "Max Steelspike": "774",
    "Max Strike": "760",
    "Max Wyrmwind": "768",
    "Mean Look": "212",
    "Meditate": "96",
    "Me First": "382",
    "Mega Drain": "72",
    "Megahorn": "224",
    "Mega Kick": "25",
    "Mega Punch": "5",
    "Memento": "262",
    "Menacing Moonraze Maelstrom": "725",
    "Metal Burst": "368",
    "Metal Claw": "232",
    "Metal Sound": "319",
    "Meteor Assault": "794",
    "Meteor Beam": "800",
    "Meteor Mash": "309",
    "Metronome": "118",
    "Mighty Cleave": "910",
    "Milk Drink": "208",
    "Mimic": "102",
    "Mind Blown": "720",
    "Mind Reader": "170",
    "Minimize": "107",
    "Miracle Eye": "357",
    "Mirror Coat": "243",
    "Mirror Move": "119",
    "Mirror Shot": "429",
    "Mist": "54",
    "Mist Ball": "296",
    "Misty Explosion": "802",
    "Misty Terrain": "581",
    "Moonblast": "585",
    "Moongeist Beam": "714",
    "Moonlight": "236",
    "Morning Sun": "234",
    "Mortal Spin": "866",
    "Mountain Gale": "836",
    "Mud Bomb": "426",
    "Mud Shot": "341",
    "Mud-Slap": "189",
    "Mud Sport": "300",
    "Muddy Water": "330",
    "Multi-Attack": "718",
    "Mystical Fire": "595",
    "Mystical Power": "832",
    "Nasty Plot": "417",
    "Natural Gift": "363",
    "Nature Power": "267",
    "Nature's Madness": "717",
    "Needle Arm": "302",
    "Never-Ending Nightmare": "636",
    "Night Daze": "539",
    "Nightmare": "171",
    "Night Shade": "101",
    "Night Slash": "400",
    "Noble Roar": "568",
    "No Retreat": "748",
    "Noxious Torque": "898",
    "Nuzzle": "609",
    "Oblivion Wing": "613",
    "Obstruct": "792",
    "Oceanic Operetta": "697",
    "Octazooka": "190",
    "Octolock": "753",
    "Odor Sleuth": "316",
    "Ominous Wind": "466",
    "Order Up": "856",
    "Origin Pulse": "618",
    "Outrage": "200",
    "Overdrive": "786",
    "Overheat": "315",
    "Pain Split": "220",
    "Paleo Wave": "0",
    "Parabolic Charge": "570",
    "Parting Shot": "575",
    "Payback": "371",
    "Pay Day": "6",
    "Peck": "64",
    "Perish Song": "195",
    "Petal Blizzard": "572",
    "Petal Dance": "80",
    "Phantom Force": "566",
    "Photon Geyser": "722",
    "Pika Papow": "732",
    "Pin Missile": "42",
    "Plasma Fists": "721",
    "Play Nice": "589",
    "Play Rough": "583",
    "Pluck": "365",
    "Poison Fang": "305",
    "Poison Gas": "139",
    "Poison Jab": "398",
    "Poison Powder": "77",
    "Poison Sting": "40",
    "Poison Tail": "342",
    "Pollen Puff": "676",
    "Poltergeist": "809",
    "Population Bomb": "860",
    "Pounce": "884",
    "Pound": "1",
    "Powder": "600",
    "Powder Snow": "181",
    "Power Gem": "408",
    "Power Shift": "829",
    "Power Split": "471",
    "Power Swap": "384",
    "Power Trick": "379",
    "Power Trip": "681",
    "Power-Up Punch": "612",
    "Power Whip": "438",
    "Precipice Blades": "619",
    "Present": "217",
    "Prismatic Laser": "711",
    "Protect": "182",
    "Psybeam": "60",
    "Psyblade": "875",
    "Psych Up": "244",
    "Psychic": "94",
    "Psychic Fangs": "706",
    "Psychic Noise": "917",
    "Psychic Terrain": "678",
    "Psycho Boost": "354",
    "Psycho Cut": "427",
    "Psycho Shift": "375",
    "Psyshield Bash": "828",
    "Psyshock": "473",
    "Psystrike": "540",
    "Psywave": "149",
    "Pulverizing Pancake": "701",
    "Punishment": "386",
    "Purify": "685",
    "Pursuit": "228",
    "Pyro Ball": "780",
    "Quash": "511",
    "Quick Attack": "98",
    "Quick Guard": "501",
    "Quiver Dance": "483",
    "Rage": "99",
    "Rage Fist": "889",
    "Rage Powder": "476",
    "Raging Bull": "873",
    "Raging Fury": "833",
    "Rain Dance": "240",
    "Rapid Spin": "229",
    "Razor Leaf": "75",
    "Razor Shell": "534",
    "Razor Wind": "13",
    "Recover": "105",
    "Recycle": "278",
    "Reflect": "115",
    "Reflect Type": "513",
    "Refresh": "287",
    "Relic Song": "547",
    "Rest": "156",
    "Retaliate": "514",
    "Return": "216",
    "Revelation Dance": "686",
    "Revenge": "279",
    "Reversal": "179",
    "Revival Blessing": "863",
    "Rising Voltage": "804",
    "Roar": "46",
    "Roar of Time": "459",
    "Rock Blast": "350",
    "Rock Climb": "431",
    "Rock Polish": "397",
    "Rock Slide": "157",
    "Rock Smash": "249",
    "Rock Throw": "88",
    "Rock Tomb": "317",
    "Rock Wrecker": "439",
    "Role Play": "272",
    "Rolling Kick": "27",
    "Rollout": "205",
    "Roost": "355",
    "Rototiller": "563",
    "Round": "496",
    "Ruination": "877",
    "Sacred Fire": "221",
    "Sacred Sword": "533",
    "Safeguard": "219",
    "Salt Cure": "864",
    "Sand Attack": "28",
    "Sandsear Storm": "848",
    "Sandstorm": "201",
    "Sand Tomb": "328",
    "Sappy Seed": "738",
    "Savage Spin-Out": "634",
    "Scald": "503",
    "Scale Shot": "799",
    "Scary Face": "184",
    "Scorching Sands": "815",
    "Scratch": "10",
    "Screech": "103",
    "Searing Shot": "545",
    "Searing Sunraze Smash": "724",
    "Secret Power": "290",
    "Secret Sword": "548",
    "Seed Bomb": "402",
    "Seed Flare": "465",
    "Seismic Toss": "69",
    "Self-Destruct": "120",
    "Shadow Ball": "247",
    "Shadow Bone": "708",
    "Shadow Claw": "421",
    "Shadow Force": "467",
    "Shadow Punch": "325",
    "Shadow Sneak": "425",
    "Shadow Strike": "0",
    "Sharpen": "159",
    "Shattered Psyche": "648",
    "Shed Tail": "880",
    "Sheer Cold": "329",
    "Shell Side Arm": "801",
    "Shell Smash": "504",
    "Shell Trap": "704",
    "Shelter": "842",
    "Shift Gear": "508",
    "Shock Wave": "351",
    "Shore Up": "659",
    "Signal Beam": "324",
    "Silk Trap": "852",
    "Silver Wind": "318",
    "Simple Beam": "493",
    "Sing": "47",
    "Sinister Arrow Raid": "695",
    "Sizzly Slide": "735",
    "Sketch": "166",
    "Skill Swap": "285",
    "Skitter Smack": "806",
    "Skull Bash": "130",
    "Sky Attack": "143",
    "Sky Drop": "507",
    "Sky Uppercut": "327",
    "Slack Off": "303",
    "Slam": "21",
    "Slash": "163",
    "Sleep Powder": "79",
    "Sleep Talk": "214",
    "Sludge": "124",
    "Sludge Bomb": "188",
    "Sludge Wave": "482",
    "Smack Down": "479",
    "Smart Strike": "684",
    "Smelling Salts": "265",
    "Smog": "123",
    "Smokescreen": "108",
    "Snap Trap": "779",
    "Snarl": "555",
    "Snatch": "289",
    "Snipe Shot": "745",
    "Snore": "173",
    "Snowscape": "883",
    "Soak": "487",
    "Soft-Boiled": "135",
    "Solar Beam": "76",
    "Solar Blade": "669",
    "Sonic Boom": "49",
    "Soul-Stealing 7-Star Strike": "699",
    "Spacial Rend": "460",
    "Spark": "209",
    "Sparkling Aria": "664",
    "Sparkly Swirl": "740",
    "Spectral Thief": "712",
    "Speed Swap": "683",
    "Spicy Extract": "858",
    "Spider Web": "169",
    "Spike Cannon": "131",
    "Spikes": "191",
    "Spiky Shield": "596",
    "Spin Out": "859",
    "Spirit Break": "789",
    "Spirit Shackle": "662",
    "Spit Up": "255",
    "Spite": "180",
    "Splash": "150",
    "Splintered Stormshards": "727",
    "Splishy Splash": "730",
    "Spore": "147",
    "Spotlight": "671",
    "Springtide Storm": "831",
    "Stealth Rock": "446",
    "Steam Eruption": "592",
    "Steamroller": "537",
    "Steel Beam": "796",
    "Steel Roller": "798",
    "Steel Wing": "211",
    "Sticky Web": "564",
    "Stockpile": "254",
    "Stoked Sparksurfer": "700",
    "Stomp": "23",
    "Stomping Tantrum": "707",
    "Stone Axe": "830",
    "Stone Edge": "444",
    "Stored Power": "500",
    "Storm Throw": "480",
    "Strange Steam": "790",
    "Strength": "70",
    "Strength Sap": "668",
    "String Shot": "81",
    "Struggle": "165",
    "Struggle Bug": "522",
    "Stuff Cheeks": "747",
    "Stun Spore": "78",
    "Submission": "66",
    "Substitute": "164",
    "Subzero Slammer": "650",
    "Sucker Punch": "389",
    "Sunny Day": "241",
    "Sunsteel Strike": "713",
    "Supercell Slam": "916",
    "Super Fang": "162",
    "Superpower": "276",
    "Supersonic": "48",
    "Supersonic Skystrike": "626",
    "Surf": "57",
    "Surging Strikes": "818",
    "Swagger": "207",
    "Swallow": "256",
    "Sweet Kiss": "186",
    "Sweet Scent": "230",
    "Swift": "129",
    "Switcheroo": "415",
    "Swords Dance": "14",
    "Synchronoise": "485",
    "Synthesis": "235",
    "Syrup Bomb": "903",
    "Tachyon Cutter": "911",
    "Tackle": "33",
    "Tail Glow": "294",
    "Tail Slap": "541",
    "Tail Whip": "39",
    "Tailwind": "366",
    "Take Down": "36",
    "Take Heart": "850",
    "Tar Shot": "749",
    "Taunt": "269",
    "Tearful Look": "715",
    "Teatime": "752",
    "Techno Blast": "546",
    "Tectonic Rage": "630",
    "Teeter Dance": "298",
    "Telekinesis": "477",
    "Teleport": "100",
    "Temper Flare": "915",
    "Tera Blast": "851",
    "Tera Starstorm": "906",
    "Terrain Pulse": "805",
    "Thief": "168",
    "Thousand Arrows": "614",
    "Thousand Waves": "615",
    "Thrash": "37",
    "Throat Chop": "675",
    "Thunder": "87",
    "Thunderbolt": "85",
    "Thunder Cage": "819",
    "Thunderclap": "909",
    "Thunder Fang": "422",
    "Thunderous Kick": "823",
    "Thunder Punch": "9",
    "Thunder Shock": "84",
    "Thunder Wave": "86",
    "Tickle": "321",
    "Tidy Up": "882",
    "Topsy-Turvy": "576",
    "Torch Song": "871",
    "Torment": "259",
    "Toxic": "92",
    "Toxic Spikes": "390",
    "Toxic Thread": "672",
    "Trailblaze": "885",
    "Transform": "144",
    "Tri Attack": "161",
    "Trick": "271",
    "Trick-or-Treat": "567",
    "Trick Room": "433",
    "Triple Arrows": "843",
    "Triple Axel": "813",
    "Triple Dive": "865",
    "Triple Kick": "167",
    "Trop Kick": "688",
    "Trump Card": "376",
    "Twin Beam": "888",
    "Twineedle": "41",
    "Twinkle Tackle": "656",
    "Twister": "239",
    "U-turn": "369",
    "Upper Hand": "918",
    "Uproar": "253",
    "Vacuum Wave": "410",
    "V-create": "557",
    "Veevee Volley": "741",
    "Venom Drench": "599",
    "Venoshock": "474",
    "Victory Dance": "837",
    "Vine Whip": "22",
    "Vise Grip": "11",
    "Vital Throw": "233",
    "Volt Switch": "521",
    "Volt Tackle": "344",
    "Wake-Up Slap": "358",
    "Waterfall": "127",
    "Water Gun": "55",
    "Water Pledge": "518",
    "Water Pulse": "352",
    "Water Shuriken": "594",
    "Water Sport": "346",
    "Water Spout": "323",
    "Wave Crash": "834",
    "Weather Ball": "311",
    "Whirlpool": "250",
    "Whirlwind": "18",
    "Wicked Blow": "817",
    "Wicked Torque": "897",
    "Wide Guard": "469",
    "Wildbolt Storm": "847",
    "Wild Charge": "528",
    "Will-O-Wisp": "261",
    "Wing Attack": "17",
    "Wish": "273",
    "Withdraw": "110",
    "Wonder Room": "472",
    "Wood Hammer": "452",
    "Work Up": "526",
    "Worry Seed": "388",
    "Wrap": "35",
    "Wring Out": "378",
    "X-Scissor": "404",
    "Yawn": "281",
    "Zap Cannon": "192",
    "Zen Headbutt": "428",
    "Zing Zap": "716",
    "Zippy Zap": "729"
}
export default MoveTranslator;